import { render, staticRenderFns } from "./LegoCardHeader.vue?vue&type=template&id=556b8c51&scoped=true&"
import script from "./LegoCardHeader.vue?vue&type=script&lang=ts&"
export * from "./LegoCardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LegoCardHeader.vue?vue&type=style&index=0&id=556b8c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b8c51",
  null
  
)

export default component.exports